import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { Translation as T, useTranslation } from "@awe-web/shared/lib";
import { useInitialize } from "../../../util/react.js";
import { initialize, submit } from "./actions.js";
import { getB2bSignUpBenefits } from "../../../user/store.js";
import { TypeArea } from "../../../components/layout.js";
import { Row, Col } from "../../../components/grid.js";
import { ScreenHeading, ScreenSection, ScreenLoading } from "../../../components/screen.js";
import { B2C_SignUp } from "../../../routing/routes.js";
import SignUpRequestForm from "./sign_up_request_form";

import "./sign_up_request.scss";

const HERO_IMAGE = "ALG0000042";
const HEADING = "ALG0000043";
const INTRODUCTION = "ALG0000044";
const BENEFITS_IMAGE = "ALG0000045";
const BENEFITS_HEADING = "ALG0000046";
const WELCOME_DISCOUNT_HEADING = "ALG0000047";
const WELCOME_DISCOUNT_TEXT = "ALG0000048";
const LINK_B2C_SIGN_UP = "ALG0000214";

export default function B2B_SignUpRequest() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { translate } = useTranslation();

  const benefits = useSelector((state) => getB2bSignUpBenefits(state));

  const [captchaToken, setCaptchaToken] = useState();

  const onSubmit = useCallback(async (formValues) => {
    formValues = { ...formValues, captchaToken };
    const nextPath = await dispatch(submit(formValues));
    if (nextPath && nextPath.length > 0) {
      navigate(nextPath);
    }
  }, [dispatch, navigate, captchaToken]);

  const onCaptchaChange = useCallback((captchaToken) => {
    setCaptchaToken(captchaToken);
  }, []);

  const init = useCallback(async () => dispatch(initialize()), [dispatch]);
  const isReady = useInitialize(init);
  if (!isReady) {
    return <ScreenLoading />;
  }

  return (
    <div className="b2b-sign-up-request">
      <div
        className="b2b-sign-up-request__hero-image"
        style={{ backgroundImage: `url(${translate(HERO_IMAGE)})` }}
      />

      <ScreenSection>
        <TypeArea className="b2b-sign-up-request__header">
          <ScreenHeading>{translate(HEADING)}</ScreenHeading>
          <p>
            <T code={LINK_B2C_SIGN_UP} to={B2C_SignUp.path()} />
          </p>
          <p>{translate(INTRODUCTION)}</p>
        </TypeArea>

        <TypeArea>
          <Row className="b2b-sign-up-request__benefits-stage">
            <Col tablet={{ cols: 4 }} desktop={{ cols: 6 }}>
              <img className="b2b-sign-up-request__benefits-image" src={translate(BENEFITS_IMAGE)} alt="" />
            </Col>
            <Col tablet={{ cols: 4 }} desktop={{ cols: 6 }}>
              <h2 className="b2b-sign-up-request__benefits-heading">{translate(BENEFITS_HEADING)}</h2>
              <ul className="b2b-sign-up-request__benefits-list">
                {benefits.toJS().map(benefit =>
                  <li key={benefit.id} className="b2b-sign-up-request__benefit">
                    {benefit.description}
                  </li>
                )}
              </ul>
            </Col>
          </Row>
        </TypeArea>
      </ScreenSection>

      <ScreenSection main className="b2b-sign-up-request__form">
        <TypeArea>
          <Row className="b2b-sign-up-request__form-introduction">
            <Col desktop={{ cols: 8, offset: 2 }}>
              <h2>{translate(WELCOME_DISCOUNT_HEADING)}</h2>
              <p>{translate(WELCOME_DISCOUNT_TEXT)}</p>
            </Col>
          </Row>

          <SignUpRequestForm onSubmit={onSubmit} onCaptchaChange={onCaptchaChange} />
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
